import axios from '../utils/axios';

export default function analyzeCompany(adminId, params) {
    return (
        axios.get(`/admin/${adminId}/companyManagement/v1/genai/analyze`, { params })
            .then(res => {
                return res.data;
            })
            .catch(err => {
                return err;
            })
    )
}
